import { Button, DataSourceMode, ForcedCase, SaveButton, TextboxProps } from "@mcleod/components";
import { CompanySettings, Model } from "@mcleod/core";
import { ModelHierarchyLevel } from "./models/ModelHierarchyLevel";
import { HierarchyLevelData } from "./ResponsibilityHierarchyModel";

export class ResponsibilityUtil {

    private static readonly AGENCY_LOOKUP: Partial<TextboxProps> = {
        lookupModel: "lme/general/agency",
        lookupModelLayout: "lme/general/AgencyLookup",
        lookupModelAllowSearchAll: true,
        lookupModelAllowShowAllResults: true,
        lookupModelAllowFreeform: false,
        lookupModelAllowMultiSelect: false,
        lookupModelInputDelay: 300,
        lookupModelMaxResults: 10,
        lookupModelResultField: "id",
        lookupModelDisplayField: "id",
        lookupModelMinChars: 3,
        lookupModelLayoutWidth: 400
    };

    private static readonly DEFAULT_FREEFORM: Partial<TextboxProps> = {
        lookupModel: null,
        lookupModelLayout: null,
        lookupModelResultField: null,
        lookupModelDisplayField: null,
        lookupModelAllowFreeform: false,
        lookupModelAllowMultiSelect: false,
        lookupModelAllowSearchAll: true,
        forcedCase: ForcedCase.UPPER
    }

    public static async isFilterEnabled(fieldName: string): Promise<boolean> {
        const response = await Model.searchSingleRecord("lme/dispatch/agent-access-ctrl")
        const isFilterEnabled = response?.get(fieldName) === "Y";
        return isFilterEnabled;
    }

    public static getPrimaryAgencyField(): string {
        return "primary_agency";
    }

    public static getSlideoutButton(layoutMode: DataSourceMode): Button | SaveButton {
        return layoutMode === DataSourceMode.SEARCH ? this.createSearchButton() : this.createSaveButton();
    }

    public static createSearchButton(): Button {
        const button =  new Button({
            id: "ursSearchButton",
            caption: "Save & Close",
            backgroundColor: "primary",
            color: "primary.reverse",
            minWidth: 128,
            borderWidth: 0,
            rowBreak: false
        });
        return button
    }

    public static createSaveButton(): SaveButton {
        const saveButton = SaveButton.create({
            id: "ursSaveButton",
            caption: "Save",
            backgroundColor: "primary",
            color: "primary.reverse",
            borderWidth: 0,
            rowBreak: false
        });
        return saveButton;
    }

    public static getAgencyLookup(): Partial<TextboxProps> {
        return this.AGENCY_LOOKUP;
    }

    public static getDefaultFreeform(): Partial<TextboxProps> {
        return this.DEFAULT_FREEFORM;
    }

    public static getPlaceHolderText(): string {
        return "No Hierarchy has been added yet. To add a Hierarchy, click Add Hierarchy Button";
    }

    public static getCompanyName(): string {
        return "Server - " + CompanySettings.get().company_alias_name;
    }

    public static getHierarchyDescriptionLength(): number {
        return 50;
    }

    public static async getHierarchyLevelInfo(): Promise<HierarchyLevelData> {
        const hierarchyMap = new Map<number, string>();
        const hierarchyLevel = await new ModelHierarchyLevel().search();
        const modelRows = hierarchyLevel.modelRows;

        if (!modelRows.length) {
            return { hierarchyMap, highestHierarchyLevel: 0, lowestHierarchyLevel: 0};
        }

        const levelNumbers: number[] = [];
        for (const row of modelRows) {
            const { level_number, description } = row.data;
            hierarchyMap.set(level_number, description);
            levelNumbers.push(level_number);
        }

        const highestHierarchyLevel = Math.max(...levelNumbers);
        const lowestHierarchyLevel = Math.min(...levelNumbers);

        return { hierarchyMap, highestHierarchyLevel, lowestHierarchyLevel };
    }

}
